<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <b-row>
    <b-col cols="8" >
      <div class="mt-2">
        <strong style="color:#0069aa"> Detalle de todas las citas </strong>
      </div>
    </b-col>
    <b-col cols="4" class="d-flex justify-content-between align-items-left">
      <b-button variant="ligth" size="sm" style="background-color: rgba(3,93,149,0.93);margin-left: 40%;height: 33px;"
                class="button-circle shadow  text-icon "
                v-b-tooltip.hover.top.v-light
                title="Ver todas las citas"
                @click="buscarCitas(1)"
      >
        <em class="lista_numerica_svg" style="width:18px"></em>
      </b-button>
      <b-button variant="ligth" size="sm"
                class="button-circle shadow  text-icon" style="height: 33px;"
                v-b-tooltip.hover.top.v-light
                title="Ver citas con mala experiencia"
                @click="buscarCitasMalaExperiencia(1)"
      >
        <em class="dislike_svg " style="width:18px"></em>
      </b-button>
    </b-col>
  </b-row>


  <b-row>
    <b-col style=" text-align: -webkit-center;">

      <div class="contenedorTablaSinColor mt-2" style="width: 100%">

        <b-table-simple sticky-header responsive class="redondo"
                        :per-page="registrosPorPagina"
                        :current-page="paginaActual"
        >
          <b-thead class="columnasTablaSinColor">
            <b-tr>
              <b-th style="text-align: center;font-size: 12px" v-for="(field, index) in fields" :key="index">
                {{field.label}}
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(lst, i) in citas" :key="i" >
              <b-td style="text-align: center;font-size: 10px;">
                {{lst.estado_cita}}
              </b-td>
              <b-td style="text-align: center;font-size: 10px; width: 10%;">
                {{lst.fecha}}
              </b-td>
              <b-td style="text-align: center;font-size: 10px;width: 22%;">
                {{lst.motivo_cancelacion }}
              </b-td>
              <b-td style="text-align: center;font-size: 10px;">
                {{lst.tratamiento}}
              </b-td>
              <b-td style="text-align: center;font-size: 10px;">
                {{lst.nombre_doctor}}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <span v-if="loaderAcciones">
                  <b-spinner variant="primary"></b-spinner>
                </span>
        <b-alert v-if="!loaderAcciones && citas.length == 0 " variant="success" show>No hay citas</b-alert>
      </div>

      <div  class="mt-2">
        <font color="gray" style="margin-left: 38%;
              z-index: 10;
              position: absolute;"
        >{{rows}} Resultados</font>
      <b-pagination
          v-model="paginaActual"
          :total-rows="rows"
          :per-page=registrosPorPagina
          aria-controls="itemList"
          align="center"
          size="sm"
          v-if="rows > 10"
      ></b-pagination>
      </div>
    </b-col>
  </b-row>
</div>
</template>

<script>
export default {
  name: "HistorialCitasAgenda",
  props:{
    idPaciente: Number,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    paginaActual: 1,
    registrosPorPagina: 10,
    rows: 1,
    fields: [
      {key: "estado_cita", label: "Estatus", sortable: true},
      {key: "fecha", label: "Fecha", sortable: true},
      {key: "motivo_cancelacion", label: "Motivo de cancelación", sortable: true},
      {key: "tratamiento", label: "Tratamiento", sortable: true},
      {key: "nombre_doctor", label: "Doctor", sortable: true},
    ],
    citas: [],
    loaderAcciones: false,
    citasMalas: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    if (this.idPaciente !== null) {
      this.buscarCitas(this.paginaActual)
    }
  },
  watch:{
    idPaciente() {
      this.paginaActual=1;
      this.buscarCitas(this.paginaActual, true);
    },
    paginaActual() {
      if (!this.citasMalas){
        this.buscarCitas(this.paginaActual, true);
      }else{
        this.buscarCitasMalaExperiencia(this.paginaActual)
      }
    },
  },
  methods:{
    buscarCitas(pagina){
      this.citasMalas = false;
      this.loaderAcciones = true
      this.citas = [];
      this.paginaActual = pagina;
      const params = {
        idPaciente: this.idPaciente,
        pagina: this.paginaActual
      }
      this.$http.post(this.$api + 'cita/citasPaciente/agenda', params).then(respuesta => {
            if (respuesta.data.data){
              this.citas = respuesta.data.data;

              this.citas.forEach( c => {
                let extraida = c.fecha.substring(0, 10);
                c.fecha = extraida
              })
              this.rows = this.citas.length > 0 ? this.citas[0].totalCitas : 0;
            }
          }
      ).catch((error) =>{
        console.error(error);
        this.loaderAcciones = false;
      }).finally(() => {
            this.loaderAcciones = false;
          }
      )
    },
    buscarCitasMalaExperiencia(pagina){
      this.citasMalas = true;
      this.loaderAcciones = true
      this.citas = [];
      this.paginaActual = pagina;
      const params = {
        idPaciente: this.idPaciente,
        pagina: this.paginaActual
      }
      this.$http.post(this.$api + 'cita/citasCanceladasPaciente/agenda', params).then(respuesta => {
            if (respuesta.data.data){
              this.citas = respuesta.data.data;

              this.citas.forEach( c => {
                let extraida = c.fecha.substring(0, 10);
                c.fecha = extraida
              })
              this.rows = this.citas.length > 0 ? this.citas[0].totalCitas : 0;
            }
          }
      ).catch((error) =>{
        console.error(error);
        this.loaderAcciones = false;
      }).finally(() => {
            this.loaderAcciones = false;
          }
      )
    }
  },
}
</script>

<style scoped>
.table.b-table > thead > tr > .table-b-table-default {
  color: #090909 !important;
  background-color: #ffffff !important;
}
.redondo{
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}
.b-table-sticky-header > .table, .table-responsive > .table, [class*=table-responsive-] > .table {
  margin-bottom: -55px;
}
.b-table-sticky-header > .table, .table-responsive > .table, [class*=table-responsive-] > .table {
  margin-bottom: -55px !important;
}
.table th, .table td {
  padding: 0.75rem;
  padding: 0.4rem;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
  font-size: 12px;
}
.table th[data-v-3564e107], .table td[data-v-3564e107] {
  padding: 0.75rem;
  padding: 0.3rem;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
  font-size: 12px;
}
</style>